// src/pages/UserActivity/UserActivity.jsx

import React from 'react';
import UserActivityDashboard from '../../components/activity/UserActivityDashboard';

function UserActivity() {
  return <UserActivityDashboard />;
}

export default UserActivity;